import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgIcon } from '@ng-icons/core';
import { ChainRepository, ChainState, ToggleInputComponent } from 'common';
import { TranslateModule } from '@ngx-translate/core';
import { TenderlyService } from '../../../service';
import {
  ChainSettingsState,
  RebalancingRepository,
  RebalancingState,
  SettingsRepository,
} from '../../../repository';
import { RebalancingType } from '../../../enum';
import { RebalancingStep } from '../rebalancing-step.enum';

@Component({
  selector: 'common-rebalancing-simulate-on-tenderly',
  standalone: true,
  imports: [CommonModule, NgIcon, ToggleInputComponent, TranslateModule],
  templateUrl: './simulate-on-tenderly.component.html',
  styleUrls: ['./simulate-on-tenderly.component.css'],
})
export class SimulateOnTenderlyComponent implements OnInit {
  protected readonly RebalancingStep = RebalancingStep;

  public showWalletMenu = false;
  public areWalletDetailsOpen = false;
  public overrideBalancesAndAllowances = false;
  public overrideTokenSymbols = [
    'USDT',
    'USDC',
    'LINK',
    'MKR',
    'UNI',
    'AAVE',
    'SHIB',
    'MATIC',
    'SAND',
  ];

  public showVaultMenu = false;
  public areVaultDetailsOpen = false;

  public useZeroGasPrice = false;

  constructor(
    private readonly rebalancingRepository: RebalancingRepository,
    private readonly settingsRepository: SettingsRepository,
    private readonly chainRepository: ChainRepository,
    private readonly tenderlyService: TenderlyService,
  ) {}

  public ngOnInit(): void {
    if (this.rebalancingState.type === RebalancingType.WALLET) {
      this.showWalletMenu = true;
      this.overrideBalancesAndAllowances = true;
    }
    if (this.rebalancingState.type === RebalancingType.VAULT) {
      this.showVaultMenu = true;
    }
  }

  public get rebalancingState(): RebalancingState {
    return this.rebalancingRepository.store.getValue();
  }

  public get activeChainSettingsState(): ChainSettingsState | undefined {
    return this.settingsRepository.getActiveChainSetting();
  }

  public get chainState(): ChainState {
    return this.chainRepository.store.getValue();
  }

  public async onSimulateClick(): Promise<void> {
    if (!this.rebalancingState.rebalancing) {
      return Promise.resolve();
    }
    await this.tenderlyService.simulateRebalancingAndOpenLink(
      this.rebalancingState.rebalancing,
      this.overrideBalancesAndAllowances,
      this.useZeroGasPrice,
    );
  }

  public onToggleWalletDetailsClick(): void {
    this.areWalletDetailsOpen = !this.areWalletDetailsOpen;
  }

  public onToggleVaultDetailsClick(): void {
    this.areVaultDetailsOpen = !this.areVaultDetailsOpen;
  }
}
